import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Document from "./Document";
import GridConfig from "./GridConfig";

export default class Documents extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'document',
            data: null,
            loading: true,
            configName: 'documents_grid',
            moduleName: 'اسناد',
            ids: [],
            filters: {
                type: 0,
                status: 0,
            },
            f0: false,
            f1: true,
            f2: true,
            f3: true,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
        this.state.topFilter = (
            <div className="pull-left" style={{ "marginTop": "-3px" }}>
                <a className="btn btn-no-frame btn-lg" onClick={e => this.DocumentNumbersReset()} title="مرتب سازی اسناد">
                    <span className="fa fa-sort" aria-hidden="true"></span>
                </a>
                <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" onChange={e => this.filterList(e, 0)} id="doc_ch1" defaultChecked={this.state.f0} type="checkbox" /> <span>اتوماتیک</span></div>
                <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" onChange={e => this.filterList(e, 1)} id="doc_ch2" defaultChecked={this.state.f1} type="checkbox" /> <span>دستی</span></div>
                <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" onChange={e => this.filterList(e, 2)} id="doc_ch3" defaultChecked={this.state.f2} type="checkbox" /> <span>تایید شده</span></div>
                <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" onChange={e => this.filterList(e, 3)} id="doc_ch4" defaultChecked={this.state.f3} type="checkbox" /> <span>ذخیره موقت</span></div>
            </div>)
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    setChecked(e, id) {
        var t = [];
        this.state.Ids.forEach(i => {
            if (i != id) t.push(i);
        });
        if (e.target.checked) t.push(id);
        this.state.Ids = t;
    }

    DocumentNumbersReset() {
        this.httpPost("/api/v1/documents/numberrest", {
            action: "new"
        })
            .then(form_data => {
                this.refreshData();
            });
    }
    filterList(e, v) {
        if (e.target.checked) {
            if (v == 0) this.state.f0 = true;
            if (v == 1) this.state.f1 = true;
            if (v == 2) this.state.f2 = true;
            if (v == 3) this.state.f3 = true;
        } else {
            if (v == 0) this.state.f0 = false;
            if (v == 1) this.state.f1 = false;
            if (v == 2) this.state.f2 = false;
            if (v == 3) this.state.f3 = false;
        }
        var t = '';
        if (this.state.f0)
            t += '0';
        if (this.state.f1)
            t += '1';
        if (this.state.f2)
            t += '2';
        if (this.state.f3)
            t += '3';
        this.state.list_url = "/customer/documents/list/" + t;
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Document Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "number", caption: "شماره", show: true },
                { field: "number2", caption: "عطف", show: true },
                { field: "dateString", caption: "تاریخ", show: true },
                { field: "description", caption: "شرح", show: true },
                { field: "typeString", caption: "نوع", show: true },
                { field: "sumBed", caption: "مبلغ", show: true },
                { field: "sourceString", caption: "سیستم صدور", show: true },
                { field: "statusString", caption: "وضعیت", show: true },
                { field: "note", caption: "یادداشت داخلی", show: false },
                { field: "automatic", caption: "اتوماتیک", show: true },
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'number' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.number}</a> } });
            if (f.field == 'number2' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'dateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'description' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'typeString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'sumBed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.sumBed) } });
            if (f.field == 'sourceString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'statusString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'note' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'automatic' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'boolean' });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="container">
            {this.getToolBar(false)}
            {this.renderAgGrid({
                columnDefs: this.getColumns()
            })}
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}